export default __webpack_public_path__ + "assets/media/trophy.1e36ed71.jpg";